import {
  getString,
  getLeoUuid,
  LeoUUID,
  getLeoTimestamp,
  LeoTimestamp,
  getLeoDate,
  LeoDate,
} from "@surya-digital/leo-ts-types";

export interface GetProjectSpocsPaginationResponseDTO {
  name: string;
  emailAddress: string;
  spocId: string;
  projectId: string;
  addedOn: string;
  expiresOn: string;
}

export class GetProjectSpocsPaginationResponse {
  readonly isGetProjectSpocsPaginationResponseGetProjectSpocsPaginationResponse: boolean = true;

  readonly name: string;
  readonly emailAddress: string;
  readonly spocId: LeoUUID;
  readonly projectId: LeoUUID;
  readonly addedOn: LeoTimestamp;
  readonly expiresOn: LeoDate;


  constructor(
  name: string, 
  emailAddress: string, 
  spocId: LeoUUID, 
  projectId: LeoUUID, 
  addedOn: LeoTimestamp, 
  expiresOn: LeoDate
  ) {
    GetProjectSpocsPaginationResponse.validateName(name);
    this.name = name;
    GetProjectSpocsPaginationResponse.validateEmailAddress(emailAddress);
    this.emailAddress = emailAddress;
    this.spocId = spocId;
    this.projectId = projectId;
    this.addedOn = addedOn;
    this.expiresOn = expiresOn;
  }

  static fromDTO(dto: GetProjectSpocsPaginationResponseDTO): GetProjectSpocsPaginationResponse {
    const name = getString(dto, "name", InvalidGetProjectSpocsPaginationResponseNameError);
    const emailAddress = getString(dto, "emailAddress", InvalidGetProjectSpocsPaginationResponseEmailAddressError);
    const spocId = getLeoUuid(dto, "spocId", InvalidGetProjectSpocsPaginationResponseSpocIdError);
    const projectId = getLeoUuid(dto, "projectId", InvalidGetProjectSpocsPaginationResponseProjectIdError);
    const addedOn = getLeoTimestamp(dto, "addedOn", InvalidGetProjectSpocsPaginationResponseAddedOnError);
    const expiresOn = getLeoDate(dto, "expiresOn", InvalidGetProjectSpocsPaginationResponseExpiresOnError);
    return new GetProjectSpocsPaginationResponse(
      name,
      emailAddress,
      spocId,
      projectId,
      addedOn,
      expiresOn
    );
  }

  toDTO(): GetProjectSpocsPaginationResponseDTO {
    const dto: GetProjectSpocsPaginationResponseDTO = {
        name: this.name,
        emailAddress: this.emailAddress,
        spocId: this.spocId.toDTO(),
        projectId: this.projectId.toDTO(),
        addedOn: this.addedOn.toDTO(),
        expiresOn: this.expiresOn.toDTO()
    };
    return dto;
  }
  private static validateName = (name: string): void => {
    if(name.trim().length === 0) {
      throw new InvalidGetProjectSpocsPaginationResponseNameNonEmptyError(
        `Attribute name cannot be an empty string.`
      );
    }
  }
  private static validateEmailAddress = (emailAddress: string): void => {
    if(emailAddress.trim().length === 0) {
      throw new InvalidGetProjectSpocsPaginationResponseEmailAddressNonEmptyError(
        `Attribute emailAddress cannot be an empty string.`
      );
    }
  }
  
}

GetProjectSpocsPaginationResponse.prototype.toString = function toString(): string {
  return `GetProjectSpocsPaginationResponse(name='${this.name}',emailAddress='${this.emailAddress}',spocId='${this.spocId}',projectId='${this.projectId}',addedOn='${this.addedOn}',expiresOn='${this.expiresOn}')`;
};

export class InvalidGetProjectSpocsPaginationResponseError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsPaginationResponseError";
  }
}
export class InvalidGetProjectSpocsPaginationResponseNameError extends InvalidGetProjectSpocsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsPaginationResponseNameError";
  }
}

export class InvalidGetProjectSpocsPaginationResponseNameNonEmptyError extends InvalidGetProjectSpocsPaginationResponseNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsPaginationResponseNameNonEmptyError";
  }
}

export class InvalidGetProjectSpocsPaginationResponseEmailAddressError extends InvalidGetProjectSpocsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsPaginationResponseEmailAddressError";
  }
}

export class InvalidGetProjectSpocsPaginationResponseEmailAddressNonEmptyError extends InvalidGetProjectSpocsPaginationResponseEmailAddressError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsPaginationResponseEmailAddressNonEmptyError";
  }
}

export class InvalidGetProjectSpocsPaginationResponseSpocIdError extends InvalidGetProjectSpocsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsPaginationResponseSpocIdError";
  }
}

export class InvalidGetProjectSpocsPaginationResponseProjectIdError extends InvalidGetProjectSpocsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsPaginationResponseProjectIdError";
  }
}

export class InvalidGetProjectSpocsPaginationResponseAddedOnError extends InvalidGetProjectSpocsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsPaginationResponseAddedOnError";
  }
}

export class InvalidGetProjectSpocsPaginationResponseExpiresOnError extends InvalidGetProjectSpocsPaginationResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetProjectSpocsPaginationResponseExpiresOnError";
  }
}
